{% block prems_premium_item_products %}
    <sw-page class="prems-premium-item">
        {% block prems_premium_item_smart_bar_header %}
            <template #smart-bar-header>
                {% block prems_premium_item_smart_bar_header_title %}
                    <h2>
                        {% block prems_premium_item_smart_bar_header_title_text %}
                            {{ $tc('prems-premium-item.text-overview') }}
                        {% endblock %}
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        <template #content>
            {% block prems_premium_item_products_content %}
                <div class="prems-premium-item__content">
                    {% block prems_premium_item_component_navigation %}
                    {% endblock %}
                    <div class="prems-premium-item-carts-list__content" v-if="isAdvancedVersion">

                        {% block prems_premium_item_carts_list_grid %}
                            <sw-data-grid
                                    ref="premiumItemProductsGrid"
                                    :data-source="mappedPremiumItems"
                                    :columns="premiumItemProductColumns"
                                    :show-settings="false"
                                    :show-actions="false"
                                    :show-selection="false"
                                    :sort-by="currentSortBy"
                                    :sort-direction="sortDirection"
                                    :is-loading="isLoading"
                                    :allow-column-edit="false"
                                    identifier="prems-premium-item-products-list"
                                    :disable-data-fetching="true"
                                    :maximum-select-items="100"
                                    @column-sort="onSortColumn"
                                    @page-change="onPageChange"
                                    @selection-change="updateSelection"
                            >
                                {% block prems_premium_item_products_list_grid_columns_ %}
                                    {% block prems_premium_item_products_list_grid_columns_product_name %}
                                        <template #column-product="{ item }">
                                            <router-link :to="{ name: 'sw.product.detail', params: { id: item.id } }">
                                                <sw-product-variant-info :variations="item.variation" :titleTerm="item.translated.name">
                                                    {{ item.name || item.translated.name }}
                                                </sw-product-variant-info>
                                            </router-link>
                                        </template>
                                    {% endblock %}

                                    {% block prems_premium_item_products_list_grid_columns_active %}
                                        <mt-icon
                                                v-if="item.active"
                                                name="regular-checkmark-xs"
                                                size="16px"
                                                class="is--active"
                                        />
                                        <mt-icon
                                                v-else
                                                name="regular-times-s"
                                                size="16px"
                                                class="is--inactive"
                                        />
                                    {% endblock %}

                                    {% block prems_premium_item_products_list_grid_columns_count %}
                                        <template #column-orderCount="{ item }">
                                            {{ item.orderCount }}
                                        </template>
                                    {% endblock %}
                                {% endblock %}

                                <template #pagination>
                                    {% block prems_premium_item_products_list_grid_pagination %}
                                        <sw-pagination
                                                :page="page"
                                                :limit="limit"
                                                :total="total"
                                                :total-visible="7"
                                                @page-change="onPageChange"
                                        />
                                    {% endblock %}
                                </template>
                            </sw-data-grid>
                        {% endblock %}
                    </div>
                    <prems-premium-item-iap-list v-else></prems-premium-item-iap-list>
                </div>
            {% endblock %}
        </template>
    </sw-page>
{% endblock %}